export default __webpack_public_path__ + "static/media/circle-chevron-right.d5ff62f9.svg";